import { render, staticRenderFns } from "./TotalList.vue?vue&type=template&id=24038300&scoped=true"
import script from "./TotalList.vue?vue&type=script&lang=js"
export * from "./TotalList.vue?vue&type=script&lang=js"
import style0 from "./TotalList.vue?vue&type=style&index=0&id=24038300&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24038300",
  null
  
)

export default component.exports